import { useState } from "react";
import {formatModelNumber} from "../helpers/statisticModelDisplay";
export default function StatisticModelComparison({ comparison, en }) {
  const [page, setPage] = useState(0),
    t = (a, b) => (en ? b : a),
    fmt = (n) =>
      Number.isFinite(n)
        ? n.toLocaleString(en ? "en-GB" : "de-DE", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
        : "—";
  if (!comparison) return null;
  const s = comparison.summary,
    rows = comparison.rows || [],
    pair = (v, actual = false) => (v ? `${actual ? formatModelNumber(v.home,en,{digits:0}) : fmt(v.home)} / ${actual ? formatModelNumber(v.away,en,{digits:0}) : fmt(v.away)}` : "—");
  const triple = (v, scale = 1) =>
    ["homewinprob", "drawprob", "awaywinprob"]
      .map((k) => fmt(Number.isFinite(v?.[k]) ? v[k] * scale : null))
      .join(" / ");
  return (
    <details className="sm-comparison">
      <summary>
        {t("Direkter Modellvergleich", "Direct model comparison")}
      </summary>
      <p>
        {t(
          "Saisonübersicht · Differenz = Statistikmodell − Ergebnismodell",
          "Season summary · difference = statistics model − result model"
        )}
      </p>
      <p>
        {t("Vergleichbare Fixtures", "Comparable fixtures")}:{" "}
        {s.comparable_fixtures} / {s.fixtures} ·{" "}
        {t(
          "Mittlere absolute xG-Abweichung je Seite",
          "Mean absolute xG difference per side"
        )}
        : {fmt(s.mean_absolute_xg_difference)} · Δ Home / Away:{" "}
        {fmt(s.mean_difference_home)} / {fmt(s.mean_difference_away)} ·{" "}
        {t(
          "Fixtures mit |Δ| > 0,50 auf mindestens einer Seite",
          "Fixtures with |Δ| > 0.50 on either side"
        )}
        : {s.large_deviation_fixtures}
      </p>
      <p>
        {t(
          "— bedeutet fehlende Vergleichsdaten. Ergebnisprognosen werden ausschließlich gelesen. Should Goals stammen aus dem Statistikmodell.",
          "— indicates missing comparison data. Result forecasts are read only. Should Goals come from the statistics model."
        )}
      </p>
      <div className="sm-controls">
        <button disabled={!page} onClick={() => setPage(page - 1)}>
          {t("Vergleich zurück", "Previous comparison page")}
        </button>
        <span>
          {page + 1} / {Math.max(1, Math.ceil(rows.length / 50))}
        </span>
        <button
          disabled={(page + 1) * 50 >= rows.length}
          onClick={() => setPage(page + 1)}
        >
          {t("Vergleich weiter", "Next comparison page")}
        </button>
      </div>
      <div className="sm-grid sm-fixtures">
        <table aria-label={t("Modellvergleich", "Model comparison")}>
          <thead>
            <tr>
              {[
                "Fixture ID",
                t("Datum", "Date"),
                t("Spiel", "Fixture"),
                t("Ergebnis xG H/A", "Result xG H/A"),
                t("Statistik xG H/A", "Statistics xG H/A"),
                "Δ xG H/A",
                t("Ergebnis 1/X/2 %", "Result 1/X/2 %"),
                t("Statistik 1/X/2 %", "Statistics 1/X/2 %"),
                t("Ergebnis Fair Odds", "Result fair odds"),
                t("Statistik Fair Odds", "Statistics fair odds"),
                "Actual Goals H/A",
                "Should Goals H/A",
                t("Ergebnisquelle", "Result source"),
              ].map((x) => (
                <th key={x}>{x}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.slice(page * 50, (page + 1) * 50).map((r) => (
              <tr key={r.fixture_id}>
                <td>{r.fixture_id}</td>
                <td>{r.kickoff?.slice(0, 10)}</td>
                <th>{r.name}</th>
                <td>{pair(r.result_model?.xg)}</td>
                <td>{pair(r.statistics_model?.xg)}</td>
                <td>{pair(r.delta_xg)}</td>
                <td>{triple(r.result_model?.probabilities, 100)}</td>
                <td>{triple(r.statistics_model?.probabilities, 100)}</td>
                <td>{triple(r.result_model?.fair_odds)}</td>
                <td>{triple(r.statistics_model?.fair_odds)}</td>
                <td>{pair(r.actual_goals,true)}</td>
                <td>{pair(r.should_goals)}</td>
                <td>{r.result_model?.source || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </details>
  );
}
